import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
/* import __COLOCATED_TEMPLATE__ from './create-account.hbs'; */
import { A } from "@ember/array";
import Component, { setComponentTemplate } from "@ember/component";
import EmberObject, { action } from "@ember/object";
import { alias, notEmpty } from "@ember/object/computed";
import { service } from "@ember/service";
import { isEmpty } from "@ember/utils";
import { observes } from "@ember-decorators/object";
import $ from "jquery";
import { Promise } from "rsvp";
import { ajax } from "discourse/lib/ajax";
import { setting } from "discourse/lib/computed";
import cookie, { removeCookie } from "discourse/lib/cookie";
import { userPath } from "discourse/lib/url";
import { emailValid } from "discourse/lib/utilities";
import { wavingHandURL } from "discourse/lib/waving-hand-url";
import NameValidation from "discourse/mixins/name-validation";
import PasswordValidation from "discourse/mixins/password-validation";
import UserFieldsValidation from "discourse/mixins/user-fields-validation";
import UsernameValidation from "discourse/mixins/username-validation";
import { findAll } from "discourse/models/login-method";
import User from "discourse/models/user";
import discourseDebounce from "discourse-common/lib/debounce";
import discourseComputed, { bind } from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
import TEMPLATE from "./create-account.hbs";
let CreateAccount = (_dec = notEmpty("model.authOptions"), _dec2 = setting("enable_local_logins"), _dec3 = setting("require_invite_code"), _dec4 = alias("model.authOptions"), _dec5 = alias("model.accountEmail"), _dec6 = alias("model.accountUsername"), _dec7 = alias("model.accountName"), _dec8 = discourseComputed("hasAuthOptions", "canCreateLocal", "model.skipConfirmation"), _dec9 = discourseComputed("site.desktopView", "hasAuthOptions"), _dec10 = discourseComputed("formSubmitted"), _dec11 = discourseComputed(), _dec12 = discourseComputed("userFields", "hasAtLeastOneLoginButton", "hasAuthOptions"), _dec13 = discourseComputed("model.authOptions", "model.authOptions.can_edit_username"), _dec14 = discourseComputed("model.authOptions", "model.authOptions.can_edit_name"), _dec15 = discourseComputed("model.authOptions.auth_provider"), _dec16 = discourseComputed("serverAccountEmail", "serverEmailValidation", "model.accountEmail", "rejectedEmails.[]", "forceValidationReason"), _dec17 = discourseComputed("model.accountEmail", "model.authOptions.email", "model.authOptions.email_valid"), _dec18 = observes("emailValidation", "model.accountEmail"), _dec19 = discourseComputed("model.authOptions.associate_url", "model.authOptions.auth_provider"), (_class = class CreateAccount extends Component.extend(PasswordValidation, UsernameValidation, NameValidation, UserFieldsValidation) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "site", _descriptor, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor2, this);
    _initializerDefineProperty(this, "login", _descriptor3, this);
    _defineProperty(this, "accountChallenge", 0);
    _defineProperty(this, "accountHoneypot", 0);
    _defineProperty(this, "formSubmitted", false);
    _defineProperty(this, "rejectedEmails", A());
    _defineProperty(this, "prefilledUsername", null);
    _defineProperty(this, "userFields", null);
    _defineProperty(this, "isDeveloper", false);
    _defineProperty(this, "maskPassword", true);
    _initializerDefineProperty(this, "hasAuthOptions", _descriptor4, this);
    _initializerDefineProperty(this, "canCreateLocal", _descriptor5, this);
    _initializerDefineProperty(this, "requireInviteCode", _descriptor6, this);
    // For UsernameValidation mixin
    _initializerDefineProperty(this, "authOptions", _descriptor7, this);
    _initializerDefineProperty(this, "accountEmail", _descriptor8, this);
    _initializerDefineProperty(this, "accountUsername", _descriptor9, this);
    // For NameValidation mixin
    _initializerDefineProperty(this, "accountName", _descriptor10, this);
  }
  init() {
    super.init(...arguments);
    if (cookie("email")) {
      this.set("model.accountEmail", cookie("email"));
    }
    this.fetchConfirmationValue();
    if (this.model.skipConfirmation) {
      this.performAccountCreation().finally(() => this.set("model.skipConfirmation", false));
    }
  }
  actionOnEnter(event) {
    if (!this.submitDisabled && event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      this.createAccount();
      return false;
    }
  }
  selectKitFocus(event) {
    const target = document.getElementById(event.target.getAttribute("for"));
    if (target?.classList.contains("select-kit")) {
      event.preventDefault();
      target.querySelector(".select-kit-header").click();
    }
  }
  showCreateForm(hasAuthOptions, canCreateLocal, skipConfirmation) {
    return (hasAuthOptions || canCreateLocal) && !skipConfirmation;
  }
  showExternalLoginButtons(desktopView, hasAuthOptions) {
    return desktopView && !hasAuthOptions;
  }
  submitDisabled() {
    return this.formSubmitted;
  }
  wavingHandURL() {
    return wavingHandURL();
  }
  modalBodyClasses(userFields, hasAtLeastOneLoginButton, hasAuthOptions) {
    const classes = [];
    if (userFields) {
      classes.push("has-user-fields");
    }
    if (hasAtLeastOneLoginButton && !hasAuthOptions) {
      classes.push("has-alt-auth");
    }
    if (!this.canCreateLocal) {
      classes.push("no-local-logins");
    }
    return classes.join(" ");
  }
  usernameDisabled(authOptions, canEditUsername) {
    return authOptions && !canEditUsername;
  }
  nameDisabled(authOptions, canEditName) {
    return authOptions && !canEditName;
  }
  fullnameRequired() {
    return this.siteSettings.full_name_required || this.siteSettings.enable_names;
  }
  passwordRequired(authProvider) {
    return isEmpty(authProvider);
  }
  disclaimerHtml() {
    if (this.site.tos_url && this.site.privacy_policy_url) {
      return I18n.t("create_account.disclaimer", {
        tos_link: this.site.tos_url,
        privacy_link: this.site.privacy_policy_url
      });
    }
  }

  // Check the email address
  emailValidation(serverAccountEmail, serverEmailValidation, email, rejectedEmails, forceValidationReason) {
    const failedAttrs = {
      failed: true,
      ok: false,
      element: document.querySelector("#new-account-email")
    };
    if (serverAccountEmail === email && serverEmailValidation) {
      return serverEmailValidation;
    }

    // If blank, fail without a reason
    if (isEmpty(email)) {
      return EmberObject.create(Object.assign(failedAttrs, {
        message: I18n.t("user.email.required"),
        reason: forceValidationReason ? I18n.t("user.email.required") : null
      }));
    }
    if (rejectedEmails.includes(email) || !emailValid(email)) {
      return EmberObject.create(Object.assign(failedAttrs, {
        reason: I18n.t("user.email.invalid")
      }));
    }
    if (this.get("model.authOptions.email") === email && this.get("model.authOptions.email_valid")) {
      return EmberObject.create({
        ok: true,
        reason: I18n.t("user.email.authenticated", {
          provider: this.authProviderDisplayName(this.get("model.authOptions.auth_provider"))
        })
      });
    }
    return EmberObject.create({
      ok: true,
      reason: I18n.t("user.email.ok")
    });
  }
  checkEmailAvailability() {
    if (!this.emailValidation.ok || this.serverAccountEmail === this.model.accountEmail) {
      return;
    }
    return User.checkEmail(this.model.accountEmail).then(result => {
      if (this.isDestroying || this.isDestroyed) {
        return;
      }
      if (result.failed) {
        this.setProperties({
          serverAccountEmail: this.model.accountEmail,
          serverEmailValidation: EmberObject.create({
            failed: true,
            element: document.querySelector("#new-account-email"),
            reason: result.errors[0]
          })
        });
      } else {
        this.setProperties({
          serverAccountEmail: this.model.accountEmail,
          serverEmailValidation: EmberObject.create({
            ok: true,
            reason: I18n.t("user.email.ok")
          })
        });
      }
    }).catch(() => {
      this.setProperties({
        serverAccountEmail: null,
        serverEmailValidation: null
      });
    });
  }
  emailDisabled() {
    return this.get("model.authOptions.email") === this.model.accountEmail && this.get("model.authOptions.email_valid");
  }
  authProviderDisplayName(providerName) {
    const matchingProvider = findAll().find(provider => {
      return provider.name === providerName;
    });
    return matchingProvider ? matchingProvider.get("prettyName") : providerName;
  }
  prefillUsername() {
    if (this.prefilledUsername) {
      // If username field has been filled automatically, and email field just changed,
      // then remove the username.
      if (this.model.accountUsername === this.prefilledUsername) {
        this.set("model.accountUsername", "");
      }
      this.set("prefilledUsername", null);
    }
    if (this.get("emailValidation.ok") && (isEmpty(this.model.accountUsername) || this.get("model.authOptions.email"))) {
      // If email is valid and username has not been entered yet,
      // or email and username were filled automatically by 3rd party auth,
      // then look for a registered username that matches the email.
      discourseDebounce(this, this.fetchExistingUsername, 500);
    }
  }

  // Determines whether at least one login button is enabled
  hasAtLeastOneLoginButton() {
    return findAll().length > 0;
  }
  fetchConfirmationValue() {
    if (this._challengeDate === undefined && this._hpPromise) {
      // Request already in progress
      return this._hpPromise;
    }
    this._hpPromise = ajax("/session/hp.json").then(json => {
      if (this.isDestroying || this.isDestroyed) {
        return;
      }
      this._challengeDate = new Date();
      // remove 30 seconds for jitter, make sure this works for at least
      // 30 seconds so we don't have hard loops
      this._challengeExpiry = parseInt(json.expires_in, 10) - 30;
      if (this._challengeExpiry < 30) {
        this._challengeExpiry = 30;
      }
      this.setProperties({
        accountHoneypot: json.value,
        accountChallenge: json.challenge.split("").reverse().join("")
      });
    }).finally(() => this._hpPromise = undefined);
    return this._hpPromise;
  }
  performAccountCreation() {
    if (!this._challengeDate || new Date() - this._challengeDate > 1000 * this._challengeExpiry) {
      return this.fetchConfirmationValue().then(() => this.performAccountCreation());
    }
    const attrs = {
      accountName: this.model.accountName,
      accountEmail: this.model.accountEmail,
      accountPassword: this.accountPassword,
      accountUsername: this.model.accountUsername,
      accountChallenge: this.accountChallenge,
      inviteCode: this.inviteCode,
      accountPasswordConfirm: this.accountHoneypot
    };
    const destinationUrl = this.get("model.authOptions.destination_url");
    if (!isEmpty(destinationUrl)) {
      cookie("destination_url", destinationUrl, {
        path: "/"
      });
    }

    // Add the userFields to the data
    if (!isEmpty(this.userFields)) {
      attrs.userFields = {};
      this.userFields.forEach(f => attrs.userFields[f.get("field.id")] = f.get("value"));
    }
    this.set("formSubmitted", true);
    return User.createAccount(attrs).then(result => {
      if (this.isDestroying || this.isDestroyed) {
        return;
      }
      this.set("isDeveloper", false);
      if (result.success) {
        // invalidate honeypot
        this._challengeExpiry = 1;

        // Trigger the browser's password manager using the hidden static login form:
        const $hidden_login_form = $("#hidden-login-form");
        $hidden_login_form.find("input[name=username]").val(attrs.accountUsername);
        $hidden_login_form.find("input[name=password]").val(attrs.accountPassword);
        $hidden_login_form.find("input[name=redirect]").val(userPath("account-created"));
        $hidden_login_form.submit();
        return new Promise(() => {}); // This will never resolve, the page will reload instead
      } else {
        this.set("flash", result.message || I18n.t("create_account.failed"));
        if (result.is_developer) {
          this.set("isDeveloper", true);
        }
        if (result.errors && result.errors.email && result.errors.email.length > 0 && result.values) {
          this.rejectedEmails.pushObject(result.values.email);
        }
        if (result.errors && result.errors.password && result.errors.password.length > 0) {
          this.rejectedPasswords.pushObject(attrs.accountPassword);
        }
        this.set("formSubmitted", false);
        removeCookie("destination_url");
      }
    }, () => {
      this.set("formSubmitted", false);
      removeCookie("destination_url");
      return this.set("flash", I18n.t("create_account.failed"));
    });
  }
  associateHtml(url, provider) {
    if (!url) {
      return;
    }
    return I18n.t("create_account.associate", {
      associate_link: url,
      provider: I18n.t(`login.${provider}.name`)
    });
  }
  togglePasswordMask() {
    this.toggleProperty("maskPassword");
  }
  externalLogin(provider) {
    // we will automatically redirect to the external auth service
    this.login.externalLogin(provider, {
      signup: true
    });
  }
  createAccount() {
    this.set("flash", "");
    this.set("forceValidationReason", true);
    const validation = [this.emailValidation, this.usernameValidation, this.nameValidation, this.passwordValidation, this.userFieldsValidation].find(v => v.failed);
    if (validation) {
      const element = validation.element;
      if (element) {
        if (element.tagName === "DIV") {
          if (element.scrollIntoView) {
            element.scrollIntoView();
          }
          element.click();
        } else {
          element.focus();
        }
      }
      return;
    }
    this.set("forceValidationReason", false);
    this.performAccountCreation();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "login", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasAuthOptions", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "canCreateLocal", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "requireInviteCode", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "authOptions", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "accountEmail", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "accountUsername", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "accountName", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "actionOnEnter", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "actionOnEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectKitFocus", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "selectKitFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCreateForm", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "showCreateForm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showExternalLoginButtons", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "showExternalLoginButtons"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitDisabled", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "submitDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wavingHandURL", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "wavingHandURL"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "modalBodyClasses", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "modalBodyClasses"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "usernameDisabled", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "usernameDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nameDisabled", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "nameDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fullnameRequired", [discourseComputed], Object.getOwnPropertyDescriptor(_class.prototype, "fullnameRequired"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "passwordRequired", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "passwordRequired"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disclaimerHtml", [discourseComputed], Object.getOwnPropertyDescriptor(_class.prototype, "disclaimerHtml"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "emailValidation", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "emailValidation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkEmailAvailability", [action], Object.getOwnPropertyDescriptor(_class.prototype, "checkEmailAvailability"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "emailDisabled", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "emailDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "prefillUsername", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "prefillUsername"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasAtLeastOneLoginButton", [discourseComputed], Object.getOwnPropertyDescriptor(_class.prototype, "hasAtLeastOneLoginButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "associateHtml", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "associateHtml"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togglePasswordMask", [action], Object.getOwnPropertyDescriptor(_class.prototype, "togglePasswordMask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "externalLogin", [action], Object.getOwnPropertyDescriptor(_class.prototype, "externalLogin"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createAccount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createAccount"), _class.prototype)), _class));
export { CreateAccount as default };
setComponentTemplate(TEMPLATE, CreateAccount);